import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { PartyPopper } from "lucide-react";

const SEEN_KEY = "grabber_seen_bid_popups";
const MAX_AGE_MS = 10 * 60 * 1000;

export default function BidAlert() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [notif, setNotif] = useState(null);

  useEffect(() => {
    if (!user) return;
    const check = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const { data } = await api.get("/notifications");
        const seen = new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"));
        const fresh = data.filter(n =>
          n.type === "bid_received" && !n.is_read && !seen.has(n.id) &&
          Date.now() - new Date(n.created_at).getTime() < MAX_AGE_MS
        );
        if (fresh.length > 0) {
          fresh.forEach(n => seen.add(n.id));
          localStorage.setItem(SEEN_KEY, JSON.stringify([...seen].slice(-100)));
          setNotif(fresh[0]);
        }
      } catch {}
    };
    check();
    const iv = setInterval(check, 15000);
    return () => clearInterval(iv);
  }, [user]);

  if (!notif) return null;

  return (
    <Dialog open onOpenChange={(o) => { if (!o) setNotif(null); }}>
      <DialogContent className="max-w-sm" data-testid="bid-alert-dialog">
        <DialogHeader>
          <div className="w-12 h-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-2">
            <PartyPopper className="w-6 h-6" />
          </div>
          <DialogTitle>Du har modtaget et bud! 🎉</DialogTitle>
          <DialogDescription>{notif.message}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => setNotif(null)} data-testid="bid-alert-dismiss">Senere</Button>
          <Button onClick={() => { const id = notif.job_id; setNotif(null); navigate(`/jobs/${id}`); }} data-testid="bid-alert-view">
            Se bud
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
